import React from "react";
import butterChicken from "../../assets/ButterChicken.png";
import paneerTikka from "../../assets/Paneer.png";
import vegBiryani from "../../assets/FriedRice.png";

const styles = {
  section: {
    padding: "4rem 2rem",
    backgroundColor: "#FFEDE3",
    textAlign: "center",
    fontFamily: "'Poppins', sans-serif",
  },
  heading: {
    fontSize: "2rem",
    fontWeight: "bold",
    marginBottom: "0.5rem",
  },
  highlight: {
    color: "#f97316",
  },
  subText: {
    color: "#555",
    maxWidth: "600px",
    margin: "0 auto 2rem",
    fontSize: "1rem",
  },
  cardContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "5rem",
    flexWrap: "wrap",
    cursor: "pointer",
  },
  card: {
    background: "#fff",
    borderRadius: "12px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    width: "300px",
    height: "400px",
    textAlign: "left",
    overflow: "hidden",
    position: "relative",
    cursor: "pointer",
  },

  badge: {
    position: "absolute",
    right: "0px",
    background: "#ef4444",
    color: "#fff",
    fontSize: "1rem",
    padding: "0.25rem 0.5rem",
    borderRadius: "6px",
  },
  vegBadge: {
    position: "absolute",
    right: "0px",
    background: "#22c55e",
    color: "#fff",
    fontSize: "1rem",
    padding: "0.25rem 0.5rem",
    borderRadius: "6px",
  },
  image: {
    width: "100%",
    height: "180px",
    objectFit: "cover",
    padding: "0.5rem",
  },
  cardContent: {
    padding: "1rem",
  },
  cardTitle: {
    fontWeight: "600",
    fontSize: "1.1rem",
    marginBottom: "0.5rem",
  },
  cardText: {
    color: "#666",
    fontSize: "0.9rem",
    marginBottom: "1rem",
  },
  button: {
    padding: "0.5rem 1rem",
    border: "1px solid #f97316",
    color: "#f97316",
    background: "transparent",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "0.9rem",
    fontWeight: "500",
    transition: "all 0.3s ease",
  },
  buttonHover: {
    background: "#f97316",
    color: "#fff",
  },
  fullMenuBtn: {
    marginTop: "2rem",
    background: "#f97316",
    color: "#fff",
    padding: "0.75rem 1.5rem",
    borderRadius: "30px",
    border: "none",
    fontSize: "1rem",
    fontWeight: "600",
    cursor: "pointer",
    transition: "background 0.3s ease",
  },
};

const FeaturedMeals = () => {
  const meals = [
    {
      id: 1,
      title: "Butter Chicken with Naan",
      desc: "Tender chicken pieces cooked in a rich, creamy tomato sauce, served with freshly baked naan.",
      img: butterChicken,
      badge: "Non-Veg",
      badgeStyle: styles.badge,
    },
    {
      id: 2,
      title: "Paneer Tikka Masala",
      desc: "Grilled cottage cheese cubes in a spiced tomato gravy, a vegetarian delight that’s irresistible.",
      img: paneerTikka,
      badge: "Veg",
      badgeStyle: styles.vegBadge,
    },
    {
      id: 3,
      title: "Vegetable Biryani",
      desc: "Fragrant basmati rice cooked with mixed vegetables and aromatic spices, a complete veg meal.",
      img: vegBiryani,
      badge: "Veg",
      badgeStyle: styles.vegBadge,
    },
  ];

  return (
    <section style={styles.section}>
      <h2 style={styles.heading}>
        Our <span style={styles.highlight}>Featured</span> Meals
      </h2>
      <p style={styles.subText}>
        Discover our most loved dishes that keep our customers coming back for
        more.
      </p>

      <div style={styles.cardContainer}>
        {meals.map((meal) => (
          <div
            key={meal.id}
            style={styles.card}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-8px) scale(1.03)";
              e.currentTarget.style.boxShadow = "0 12px 24px rgba(0,0,0,0.3)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0) scale(1)";
              e.currentTarget.style.boxShadow = "0 8px 16px rgba(0,0,0,0.2)";
            }}
          >
            <img src={meal.img} alt={meal.title} style={styles.image} />
            <span style={meal.badgeStyle}>{meal.badge}</span>
            <div style={styles.cardContent}>
              <h3 style={styles.cardTitle}>{meal.title}</h3>
              <p style={styles.cardText}>{meal.desc}</p>
              <button
                style={styles.button}
                onMouseEnter={(e) => {
                  e.target.style.background = "#f97316";
                  e.target.style.color = "#fff";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "transparent";
                  e.target.style.color = "#f97316";
                  onclick = () => window.location.href = "/menu";
                }}
              >
                View Details →
              </button>
            </div>
          </div>
        ))}
      </div>

      <button
        style={styles.fullMenuBtn}
        onMouseEnter={(e) => (e.target.style.background = "#ea580c")}
        onMouseLeave={(e) => (e.target.style.background = "#f97316")}
        onClick={() => window.location.href = "/menu"}
      >
        Check Out Full Menu List →
      </button>
    </section>
  );
};

export default FeaturedMeals;
